module.exports = __webpack_public_path__ + "img/feature-push-notification.053fb896.png";